export const content = "You and other session participants will need to be in the same place, as BetterHelp doesn\u2019t currently support calls from multiple locations.\n";
